import React from 'react';
import {PROPERTIES} from "../../consts/tables";
import Alert from "../Alert";
import {manageData} from "../../requests/CRUD";
import PropertyForm from '../PropertyForm/PropertyForm';
import { priceToString } from '../CRUDProperty/CRUDProperty';
import { sendEmailNotification, sendOffMarketSellerEmail } from '../../requests/emailRequests';
import { url } from '../../consts/env';
import {formatAddress} from "../../utils";
import { CREATE_UPDATE_PROPERTY } from '../Graphql/Mutations/SellerMutation';
import { ApolloConsumer } from "@apollo/client";
import { mutateData } from '../Service/graphQlService';

const priceProps = [
    'LIST_PRICE',
];

function convertFormToData(formData) {
    const data = {...formData};
    
    priceProps.forEach((key) => {
        const num = priceToString(data[key]);
        if (num !== false)
            data[key] = num;
    });
    return data;
}


function convertKeysToLowerCase(obj) {
    const newObj = {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            newObj[key.toLowerCase()] = obj[key];
        }
    }
    return newObj;
}

export default class PropertyDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            paneIndex: 0,
            isBusy: null,
            error: null,
        };
        this.client = null;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    componentDidMount() {
        const data = {...this.state.data};
        data.TRANSACTION_TYPE = 'Investment Sales';
        data.SOURCE = 'STRIVE';
        this.setState({data});
    }

    componentDidUpdate(prevProps){
        if(prevProps.resetDrawer !== this.props.resetDrawer && this.props.resetDrawer === true)
            this.setState({data:{TRANSACTION_TYPE:'Investment Sales',SOURCE:'STRIVE'}});
    }

    handleSubmit(e) {
        e.preventDefault();
        this.saveData();
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(query, queryType, x, key) {
        if(key === 'LISTING_AGENT_1')
            query.LISTING_AGENT_1_PERCENT = '100';
        this.setState({data:query});
    }

    saveData() {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        Object.keys(this.state.data).forEach(k => {
            if (!this.state.data[k] || k === 'undefined') {
                const newData = {...this.state.data};
                delete newData[k];
                this.setState({data: newData})
            }
        });
        const data = this.state.data;
        const sellerId = this.props.sellerId;
        // let userName = this.props.userData.person.firstName + ' ' + this.props.userData.person.lastName;  old code
        let userName = this.props.userData.username ? this.props.userData.username : ""
        if(this.props.isOffMarket)
            data.STATUS = 'Off Market';
    
        // data.CREATED_BY = userName;
        // data.DATE_CREATED = new Date().toISOString().split("T")[0];
        // data.LAST_MODIFIED_BY = userName;
        // data.LAST_MODIFIED_DATE = new Date().toISOString().split("T")[0];
        data.SELLER_ID = sellerId && parseInt(sellerId);
        data.ADDRESS = formatAddress(data.ADDRESS);
        let lowerCaseConvertData = convertKeysToLowerCase(data);
  const token = localStorage.getItem('authToken');
        Promise.all([
        //     manageData({
        //         tableCode: PROPERTIES,
        //         data: [convertFormToData(data)],
        //     })
        // ])
    //       this.client.mutate({mutation:CREATE_UPDATE_PROPERTY, variables:{input:[convertFormToData(lowerCaseConvertData)]},
    //   fetchPolicy: "no-cache",
    //   context: {
    //     headers: {
    //       authorization: `Bearer ${token}`,
    //     },
    //   }})
      mutateData(CREATE_UPDATE_PROPERTY,{input:[convertFormToData(lowerCaseConvertData)]})
    ])
        .then(res => {
            if (res && res[0] && res[0].data.createOrUpdateProperty.success) {
                this.setState({isBusy: false});
                this.props.savedNewItem(res[0].data.createOrUpdateProperty.data[0]);

                if(res[0].data.createOrUpdateProperty.data[0].status === 'Off Market'){
                    const link = `${url}list?name=${res[0].data.createOrUpdateProperty.data[0].name}&source=${res[0].data.createOrUpdateProperty.data[0].source}&address=${res[0].data.createOrUpdateProperty.data[0].address}&status=${res[0].data.createOrUpdateProperty.data[0].status}&transaction_type=${res[0].data.createOrUpdateProperty.data[0].transaction_type
                    }`;
                    const property = {
                        ...res[0].data.createOrUpdateProperty.data[0],
                        link:link
                    }
                    sendEmailNotification({ data: property, type: 'off-market-seller-email' })
                }
                if (this.props.closeDrawer) {
                    this.props.closeDrawer();
                    setTimeout(() => this.setState({data: {}}));
                }
            } else {
                this.setState({
                    isBusy: null,
                    error: res && res[0] && res[0].data.createOrUpdateProperty.message ? res[0].data.createOrUpdateProperty.message : 'Unspecified error',
                });
            }
        });
    }

    render() {
        const data = this.state.data;
        return (
            <ApolloConsumer>
              {client => {
                if(!this.client){
                  this.client = client
                }
        return (
            <div>
                <PropertyForm data={data}
                           paneIndex={this.state.paneIndex}
                           handleSubmit={this.handleSubmit}
                           handleCancel={this.props.closeDrawer}
                           handleParentChange={this.handleChange}
                           handleParentDropdownChange={this.handleDropdownChange}/>
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
            </div>
        )
    }}
    </ApolloConsumer>
    
  );
    }
}